export default "__VITE_ASSET__DCNfYc9a__"